export default defineNuxtRouteMiddleware(async (to, from) => {
  const { status, login, getToken } = useAuth()
  const { link, links, init, isLoading } = useSetup()
  const { setLanguage, lang } = useLanguage()
  if(!Object.keys(links.value).length) {
    await init()
  }

  const _lang = to.path?.split('/')?.[1]
  if(_lang && _lang !== lang.value) {
    isLoading.value = true
    await setLanguage(_lang)
    await init()
    isLoading.value = false
  }

  if (import.meta.client) {    
    const authPart = link('Login')?.split('/')?.[2];
    const redirectPages = [link('Login'), link('Registration'), link('RegistrationCompleted'), link('Loyalty'), link('LoyaltyTerms')];

    if(status.value === 'unauthenticated' && getToken()) await login()
    
    if (to.path.includes(authPart)) {
      if (status.value === 'unauthenticated' && !redirectPages.includes(to.path)) {
        try {
          await login()
        } catch(e) {
          console.dir(e)
        }
      }

      if(!redirectPages.includes(to.path) && status.value !== 'authenticated') {
        window.location.href = link('Login')
      }
    }
  }
})